export const config = _sys => {
  return {
    defaultModule: 'home-icon'
  };
};